export const cssVar = (variableName: string, fallback?: string) =>
  `var(${[variableName, fallback].filter(Boolean).join(', ')})`

export const cssCalc = (...expression: Array<string | number>) =>
  `calc(${expression.join(' ')})`
